import {createActions} from 'redux-actions';
import fetchJson, {postJson, putJson, deleteJson, postForm} from '../../fetchJson';
import handleError from '../../handleError';
import {replace} from 'connected-react-router';

const actions = createActions(
	'PROFILE_COUPON_LISTING',
	'PROFILE_COUPON_DELETED',
	'PROFILE_WALLET_LISTING',
	'PROFILE_COUPON_UPDATED',
	'PROFILE_COUPON_ADDED'
);

/**
 * Action method to fetch profile coupons
 * @param {*} userUuid
 * @returns
 */
export const fetchProviderCoupons = providerUuid => (dispatch, getState) => {
	// API call to fetch coupons for user profile
	fetchJson(`/api/coupons/profile/${providerUuid}`)
		.then(coupons => {
			dispatch(actions.profileCouponListing(coupons));
		})
		.catch(handleError(dispatch));
};

/**
 * Function to fetch all coupons redeemed by current user
 * @param {*} userUuid
 * @returns
 */
export const fetchUserWalletCoupons = userUuid => (dispatch, getState) => {
	// API call to fetch coupons for user profile
	fetchJson(`/api/coupons/wallet/${userUuid}`)
		.then(coupons => {
			dispatch(actions.profileWalletListing(coupons));
		})
		.catch(handleError(dispatch));
};

export const deleteCoupon = (couponUuid, userUuid) => (dispatch, getState) => {
	// API call to fetch coupons for user profile
	putJson(`/api/coupon/${couponUuid}`, {deletedBy: userUuid})
		.then(coupon => {
			dispatch(actions.profileCouponDeleted({couponUuid: couponUuid}));
		})
		.catch(handleError(dispatch));
};

export default {
	...actions,
	fetchProviderCoupons,
	deleteCoupon,
	fetchUserWalletCoupons
};



// WEBPACK FOOTER //
// ./src/profile/coupons/profileCoupons.actions.js